export const CurrentUser = {
    GetCurrentUser: () => {
        let userdata = JSON.parse(localStorage.getItem("user"));
        return userdata;
    }
 }